/**
 * Abstract "AI product" illustration: a floating dashboard/analytics panel with
 * a neural-network motif. Pure inline SVG — no external assets.
 */
export default function HeroIllustration({ className = '' }) {
  return (
    <svg
      viewBox="0 0 520 460"
      role="img"
      aria-label="Abstract illustration of an AI analytics dashboard"
      className={className}
    >
      <defs>
        <linearGradient id="heroPanel" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#ffffff" />
          <stop offset="1" stopColor="#f0f6ff" />
        </linearGradient>
        <linearGradient id="heroBlue" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#3b82f6" />
          <stop offset="1" stopColor="#1d4ed8" />
        </linearGradient>
        <linearGradient id="heroBar" x1="0" y1="1" x2="0" y2="0">
          <stop offset="0" stopColor="#93c5fd" />
          <stop offset="1" stopColor="#2563eb" />
        </linearGradient>
        <filter id="heroShadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="24" stdDeviation="28" floodColor="#1d4ed8" floodOpacity="0.18" />
        </filter>
      </defs>

      {/* soft background blobs */}
      <circle cx="410" cy="90" r="70" fill="#dbeafe" />
      <circle cx="70" cy="360" r="54" fill="#bfdbfe" opacity="0.7" />

      {/* main panel */}
      <g filter="url(#heroShadow)">
        <rect x="70" y="70" width="380" height="300" rx="24" fill="url(#heroPanel)" stroke="#e2e8f0" />
        {/* header row */}
        <circle cx="98" cy="100" r="6" fill="#cbd5e1" />
        <circle cx="118" cy="100" r="6" fill="#cbd5e1" />
        <circle cx="138" cy="100" r="6" fill="#cbd5e1" />
        <rect x="330" y="90" width="96" height="20" rx="10" fill="url(#heroBlue)" opacity="0.15" />

        {/* line chart */}
        <polyline
          points="98,250 150,210 202,228 254,170 306,196 358,132 410,158"
          fill="none"
          stroke="url(#heroBlue)"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="358" cy="132" r="7" fill="#2563eb" stroke="#ffffff" strokeWidth="3" />

        {/* bars */}
        <rect x="98" y="288" width="26" height="54" rx="6" fill="url(#heroBar)" opacity="0.5" />
        <rect x="140" y="270" width="26" height="72" rx="6" fill="url(#heroBar)" opacity="0.65" />
        <rect x="182" y="300" width="26" height="42" rx="6" fill="url(#heroBar)" opacity="0.5" />
        <rect x="224" y="258" width="26" height="84" rx="6" fill="url(#heroBar)" />
        <rect x="266" y="284" width="26" height="58" rx="6" fill="url(#heroBar)" opacity="0.6" />
      </g>

      {/* floating "AI" node badge */}
      <g className="animate-float">
        <circle cx="440" cy="300" r="40" fill="url(#heroBlue)" />
        <text x="440" y="308" textAnchor="middle" fontSize="26" fontWeight="700" fill="#ffffff" fontFamily="ui-sans-serif, system-ui, sans-serif">
          AI
        </text>
      </g>

      {/* floating neural nodes */}
      <g className="animate-float-slow">
        <circle cx="100" cy="150" r="12" fill="#ffffff" stroke="#2563eb" strokeWidth="3" />
        <circle cx="60" cy="220" r="9" fill="#2563eb" />
        <line x1="100" y1="150" x2="60" y2="220" stroke="#93c5fd" strokeWidth="3" />
      </g>
    </svg>
  )
}
